import React from 'react';
import {Card} from 'reactstrap';
import DoctorUsersEditMembership from './DoctorUsersEditMembership';
import DoctorUsersEditExtRef from './DoctorUsersEditExtRef';

const DoctorUsersForm = () => {

  return (
    <div className="content user-manual-edit">

      <Card>
        <DoctorUsersEditMembership/>
        <DoctorUsersEditExtRef/>
      </Card>
    </div>
  );
};

export default DoctorUsersForm;
